export const filter = {
  type: {
    color: 'color',
    bodega: 'bodega',
    uva: 'uva',
    precio: 'precio',
  },
  placeholder: {
    color: 'Selecciona para filtrar por tipo de vino',
    bodega: 'Selecciona para filtrar por bodega',
    uva: 'Selecciona para filtrar por tipo de uva',
    precio: 'Selecciona para filtrar por precio',
    mobile: {
      color: 'Filtrar por tipo de vino',
      precio: 'Filtrar por precio',
    },
  },
  options: {
    precio: [
      {
        label: 'Menos de 10€',
        value: {
          min: null,
          max: 10,
        },
      },
      {
        label: 'Entre 10€ y 20€',
        value: {
          min: 11,
          max: 20,
        },
      },
      {
        label: 'Entre 20€ y 30€',
        value: {
          min: 21,
          max: 30,
        },
      },
    ],
  },
}

export const getIsPriceFilter = (filterType) =>
  filterType === filter.type.precio

export const MAX_OPTIONS_TO_FILTER = 2

export const ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_FILTER = `El máximo de opciones para filtrar es ${MAX_OPTIONS_TO_FILTER} por filtro`

export const ADVICE_MESSAGE_SHOW_WHEN_MAX_OPTIONS_TO_PRICE_FILTER = `El máximo de opciones para filtrar en este filtro es de ${
  MAX_OPTIONS_TO_FILTER - 1
}`
